// extracted by css-extract-rspack-plugin
export default {"CopyButton":"NbN6h","icon":"AaKLj","srOnly":"kX41Q"};